<template>
    <div class="area-radar-chart">
        <div class="content-1" style="height: 500px;">
            <div class="chart-content-div-header">
                <h4><small><i class="glyphicon glyphicon-signal"></i>&nbsp;&nbsp;&nbsp;#  {{ $t("128") }} ({{ periodText }}) - {{header}}</small>
                <small><i v-on:click='exporting' style='float:right;' class='glyphicon glyphicon-print my-export'></i></small></h4>
            </div>
            <div class="chart-content-div"><div v-bind:id="id"></div></div>
        </div>
    </div>
</template>

<script>

let Highcharts = require('highcharts');
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);

export default {
    name: 'area-radar-chart',
    mounted(){
        
        this.options.chart.polar = this.chartPolar
        this.options.chart.type = this.chartType
        this.chart = new Highcharts.chart(this.options);
        
    },
    watch: {
        data : function (value) {

            this.options.chart.polar = this.chartPolar
            this.options.chart.type = this.chartType
            this.options.yAxis.title.text = this.titleY
            this.chart = new Highcharts.chart(this.options);
            this.chart.series[0].setData(this.data, true);
            this.chart.xAxis[0].setCategories(this.categories);
        }
    },
    methods:{
        exporting: function(){
            this.chart.exportChart();
        },
    },
    computed: {
        periodText() {
            let period = this.filters.period;
            let year = this.filters.year;

            if(year != new Date().getFullYear() || !period) return year;

            if (period == 3 || period == 6) return period + 'm';
            if (period == 12) return '1Y';
            if (period == 'AC') return 'YTD';
        },
        chartPolar() {
            if(this.data.length <= 3){
                return false
            }
            else{
                return true
            }
        },
        chartType() {
            if(this.data.length <= 3){
                return 'column'
            }
            else{
                return 'area'
            }
        },
        titleY() {
            if(this.data.length <= 3){
                return '# Failures'
            }
            else{
                return ''
            }
        }
    },
    data(){
        return{
            chart: undefined,
            options: {
                chart: {
                    renderTo: this.id,
                    polar: true,
                    type: 'area',
                    height: 450,
                    spacingBottom: 40,
                    spacingTop: 25,
                    spacingLeft: 20,
                    spacingRight: 20,
                    backgroundColor: 'rgba(0,0,0,0)',
                },
                title: {
                    text: '',
                },
                xAxis: {
                    categories: this.categories,
                    tickmarkPlacement: 'on',
                    lineWidth: 0,
                    labels:
                    {
                        style: {
                            fontSize:'9px',
                            color: '#E0E0E3',
                        },
                        distance: 20,
                        padding: 0,
                        overflow: 'allow'
                    },
                    gridLineColor: '#707073',
                },
                pane: {
                    //size: '100%',
                },
                yAxis: {
                    gridLineInterpolation: 'polygon',
                    lineWidth: 0,
                    min: 0,
                    endOnTick: false,
                    tickInterval: 1,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: '',
                        style: {
                            color: '#E0E0E3'
                        }
                    }
                },
                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                tooltip: {
                    shared: true,
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style:{
                                fontSize: '10px'
                            }
                        },
                        // fillColor: "rgba(151,187,205,0.2)",
                        fillColor: "rgba(107, 145, 201, 0.2)",
                        strokeColor: "rgba(151,187,205,1)",
                        pointColor: "rgba(151,187,205,1)",
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(151,187,205,1)",
                        marker: {
                            fillColor: '#FFFFFF',
                            lineWidth: 2,
                            radius: 3,
                            lineColor: null // inherit from series
                        }
                    }
                },
                series: [{
                    name: 'Total',
                    data: this.data,
                    color: '#6b91c9'
                }],
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
            },
        }
    },
    props: {
        data: {
            type: Array,
        },
        categories: {
            type: Array,
        },
        id: {
            type: String,
        },
        header: {
            type: String
        },
        filters: {
            type: Object
        }
    },
}

</script>

<style scoped>

.content-1 {
    border-radius: 0;
    color: #5b5b5b;
    margin-bottom: 20px;
    min-height: 30px;
    position: relative;
}

.chart-content-div {
    padding: 5px 20px 1px;
}

.chart-content-div-header {
    padding: 8px 0 0 15px;
}

.chart-content-div-header h4{
    margin-top: -4px;
}

.chart-content-div-header h4 small{
    color: #ffffff;
}
.my-export{
    padding-right: 10px;
    cursor: pointer;
}
@media screen and (max-width: 420px) {
    .chart-content-div-header h4 small{
        font-size: 12px!important;
    }
    .my-export{
        padding-top:8px;
    }
    .chart-content-div-header h4 small{
        font-size: 13px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/Area-radar-chart.vue